import { defineStore } from "pinia";

export const useCartStore = defineStore("cart", {
  state: () => ({
    count: 0,
  }),
  getters: {
    cartCountNumber: (state) => {
      const num = Number(state.count);
      return Number.isFinite(num) && num > 0 ? num : 0;
    },
  },
  actions: {
    setCount(value: number | string) {
      const num = Number(value);
      this.count = Number.isFinite(num) && num > 0 ? num : 0;
    },
    increment(delta = 1) {
      const num = Number(delta);
      this.count = Math.max(0, this.count + (Number.isFinite(num) ? num : 0));
    },
    decrement(delta = 1) {
      const num = Number(delta);
      this.count = Math.max(0, this.count - (Number.isFinite(num) ? num : 0));
    },
  },
});
